// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-warning {\n  margin-top: 3rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.main-warning h1 {\n  font-size: 1.5rem;\n}\n", ""]);
// Exports
module.exports = exports;
